const EmployeeActions = {
    UPDATE: 'UPDATE_EMPLOYEES',
    UPDATE_ADMIN: "UPDATE_ADMIN",
    UPDATE_CUSTOMER: "UPDATE_CUSTOMER",
    UPDATE_SUPER_ADMIN: "UPDATE_SUPER_ADMIN",
}

export default EmployeeActions;